// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as CheckPenExtended } from '../../../assets/icons/extended/custom3.0/check-pen.svg?react';
import { createIcons } from '../../Icon';
const CheckPenIcon = /* @__PURE__ */ createIcons('CheckPen', {
    extended: CheckPenExtended
});
CheckPenIcon.supportedTypes = ['extended'];
CheckPenIcon.category = 'custom3.0';
export default CheckPenIcon;
